import { Component, h } from '@stencil/core';
import { defaultReview } from '@ugc-components/ugc-pdp-review/interface';
import state from '@ugc-store';
import { modalZIndex } from '@ugc-utils/modal-z-index';
import { Arrow } from '../../icons';

@Component({
  tag: 'ugc-review-dt-image-modal',
  styleUrl: 'ugc-review-dt-image-modal.scss',
  shadow: false,
})
export class UgcReviewDtImageModal {
  onChangeActiveImage = ({ assetId }) => {
    const {
      reviewImageModalData: { reviewItem },
    } = state;
    if (reviewItem && reviewItem.images.length) {
      const { images } = reviewItem;
      const imageActiveIndex = images.findIndex(image => image.assetId === assetId);
      state.reviewImageModalData = {
        ...state.reviewImageModalData,
        imageActiveIndex,
      };
    }
  };

  getImageGallaryInfo = () => {
    const {
      reviewImageModalData: { reviewItem },
    } = state;
    if (reviewItem && reviewItem.images.length) {
      const { images } = reviewItem;
      return {
        images,
      };
    }
    return {
      images: [],
    };
  };
  getPrevOrNextImage = async flag => {
    const {
      reviewImageModalData: { reviewItem, imageActiveIndex },
    } = state;
    if (reviewItem && reviewItem.images.length) {
      const { images } = reviewItem;
      const imageIndex = flag === 'prev' ? imageActiveIndex - 1 : imageActiveIndex + 1;
      if (imageIndex < 0 || imageIndex > images.length - 1) return;
      state.reviewImageModalData = {
        ...state.reviewImageModalData,
        imageActiveIndex: imageIndex,
      };
    }
  };
  handleCancel() {
    state.reviewImageModalData = {
      reviewItem: defaultReview,
      imageActiveIndex: 0,
    };
    state.isShowReviewImageModal = false;
  }

  render() {
    const {
      reviewStaticLanguage: { IDS_LBL_REVIEW_IMAGES = '', IDS_UGC_ACTIVE_IMAGE = '', IDS_UGC_REVIEW_IMAGE = '' },
      isShowReviewImageModal,
      reviewImageModalData: { reviewItem, imageActiveIndex },
    } = state;

    const { images } = this.getImageGallaryInfo();

    const renderBitImagePrevButton = imageActiveIndex !== 0 && (
      <div
        class="nav-button button-prev flex-row-center-center pointer"
        onClick={this.getPrevOrNextImage.bind(this, 'prev')}
      >
        <Arrow width="20" height="20" fill="#fff" />
      </div>
    );
    const renderBitImageNextButton = imageActiveIndex !== images.length - 1 && (
      <div
        class="nav-button button-next flex-row-center-center pointer"
        onClick={this.getPrevOrNextImage.bind(this, 'next')}
      >
        <Arrow width="20" height="20" fill="#fff" />
      </div>
    );
    const renderBigImage = images.map(({ paths: { l = '' } = {} }, index) => (
      <div class={`image-swiper-wrap flex-row-center-center ${index === imageActiveIndex ? 'active' : ''}`}>
        {l && <img src={l} alt={IDS_UGC_ACTIVE_IMAGE} />}
      </div>
    ));
    const renderBigImageSwiper = (
      <div class="big-image-wrap">
        {renderBitImagePrevButton}
        {renderBigImage}
        {renderBitImageNextButton}
      </div>
    );

    const renderSwipperImageListWrap = (
      <div class="swipper-image-list-box">
        <div class="swipper-image-list flex-row-start-center gap-4">
          {images.map(({ assetId, paths: { m = '' } = {} }, index) => (
            <div
              class={`swipper-image-box flex-row-center-center pointer`}
              onClick={this.onChangeActiveImage.bind(this, { assetId })}
            >
              {m && <img src={m} alt={IDS_UGC_REVIEW_IMAGE} />}
              {index === imageActiveIndex && <div class="active"></div>}
            </div>
          ))}
        </div>
      </div>
    );

    return (
      <ugc-modal-dialog
        isShow={isShowReviewImageModal}
        modalTitle={IDS_LBL_REVIEW_IMAGES}
        zIndex={modalZIndex['ugc-review-single-image-modal']}
        rootStyle={{ width: '800px' }}
        handleCancel={this.handleCancel.bind(this)}
      >
        {isShowReviewImageModal && (
          <div class="ugc-review-dt-images-detail-modal px-32 pb-24">
            <div class="flex-row-between-start gap-24">
              {renderBigImageSwiper}
              <div class="image-detail-review-info-wrap">
                <ugc-review-item reviewItem={reviewItem} isModal={true} handleClickImage={this.onChangeActiveImage} />
              </div>
            </div>
            <div class="mt-24 flex-row-start-center">{renderSwipperImageListWrap}</div>
          </div>
        )}
      </ugc-modal-dialog>
    );
  }
}
